import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles({
  positionTitle: {
    marginTop: 16,
    marginBottom: 8
  }
})

export default useStyles
